import { render, staticRenderFns } from "./applyTable.vue?vue&type=template&id=b7a90818&"
import script from "./applyTable.vue?vue&type=script&lang=js&"
export * from "./applyTable.vue?vue&type=script&lang=js&"
import style0 from "./applyTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/ctg-code/qihuibao-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
installComponents(component, {VDataTable})
